"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.RESULT_ADDRESS = exports.RESULT = exports.RESULTS_CONTAINER = void 0;

var _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars"),
    RESULTS_CONTAINER = (0, _cxs["default"])({
  maxHeight: "inherit",
  boxSizing: "border-box",
  " > :last-child": {
    fontSize: _vars.FONT_SIZES.small,
    textAlign: "center",
    paddingTop: "10px",
    paddingBottom: "10px"
  }
});

exports.RESULTS_CONTAINER = RESULTS_CONTAINER;
var RESULT = (0, _cxs["default"])({
  boxSizing: "border-box",
  width: "100%"
});
exports.RESULT = RESULT;
var RESULT_ADDRESS = (0, _cxs["default"])({
  color: _vars.COLOURS.grey.nevada
});
exports.RESULT_ADDRESS = RESULT_ADDRESS;